export enum SplitTestVariant {
  starterDualOffer = 'StarterDualOffer',
}
